import React, { FunctionComponent, useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import customer_logo from './../ab-inbev-logo.svg';
import { useLocation } from 'react-router-dom';
import { OrganizationSwitcher, UserButton } from '@clerk/clerk-react';
import { clerkVariables } from '../variables/clerk';
import { useNavigateWithinOrg } from '../utils/navigation';
import useHash from '../hooks/useHash';
import { useModalContext } from '../contexts/ModalContext';

const NavBar: FunctionComponent = () => {
    const location = useLocation();
    const modalButtonRef = useRef<HTMLButtonElement>(null);

    const isActive = (path: string) => location.pathname.endsWith(path);

    const navigate = useNavigateWithinOrg();

    const { setHashValue } = useHash();

    const getOrgRedirectUrl = (organization: any) => {
        // Handle the case where slug might be null
        const slug = organization?.slug || '';

        if (location.pathname.includes('/analytics')) {
            return `/orgs/${slug}/analytics`;
        } else if (location.pathname.includes('/library')) {
            return `/orgs/${slug}/library`;
        } else {
            return `/orgs/${slug}`;
        }
    };

    return (
        <div className="navbar-wrapper">
            <nav className="App-navbar">
                <div className="nav-title-container">
                    <img
                        src={customer_logo}
                        alt="Brand logo"
                        className="brand-logo"
                    />
                    Stickering Tool
                </div>
                <div className="settings-actions">
                    <div style={{ position: 'relative' }}>
                        <button
                            className="nav-button add"
                            onClick={() => {
                                // window.location.hash = 'upload'; // Sets the hash to #upload
                                navigate('/library');
                                setHashValue('upload');
                            }}
                            ref={modalButtonRef}
                        >
                            <FontAwesomeIcon icon={faPlus} />
                            {'Review'}
                        </button>
                    </div>
                    <button
                        onClick={() => {
                            navigate('/library');
                        }}
                        className={`nav-button ${
                            isActive('/library') ? 'selected' : ''
                        }`}
                    >
                        Library
                    </button>
                    <button
                        onClick={() => {
                            navigate('/analytics');
                        }}
                        className={`nav-button ${
                            isActive('/analytics') ? 'selected' : ''
                        }`}
                    >
                        Analytics
                    </button>
                </div>
                <OrganizationSwitcher
                    hidePersonal
                    afterSelectOrganizationUrl={getOrgRedirectUrl}
                    appearance={{
                        variables: clerkVariables,
                        elements: {
                            rootBox: {
                                marginLeft: '50px',
                            },
                            avatarBox: {
                                width: '26px',
                                height: '26px',
                            },
                        },
                    }}
                    organizationProfileProps={{
                        appearance: {
                            variables: clerkVariables,
                        },
                    }}
                />

                <UserButton
                    appearance={{
                        variables: clerkVariables,
                        elements: {
                            rootBox: {
                                marginLeft: '15px',
                            },
                            avatarBox: {
                                width: '28px',
                                height: '28px',
                            },
                        },
                    }}
                    userProfileProps={{
                        appearance: {
                            variables: clerkVariables,
                        },
                    }}
                ></UserButton>
            </nav>
        </div>
    );
};

export default NavBar;
